import React, { FC, useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { supplierSettingsRestCrudThunksForSupplier } from '../../thunks/supplier_settings_thunks';

const SupplierNotificationActions: FC<any> = ({
	match,
	getSupplierSettings,
	currentUser,
	supplierSettingsFetching,
	childRoutes,
}): React.ReactElement => {
	useEffect(() => {
		getSupplierSettings(encodeURIComponent(currentUser.email));
	}, []);

	const notificationType = match.params.notificationType;

	return supplierSettingsFetching ? (
		<PageLoadingPlaceholder />
	) : (
		<div>
			<Route
				path={`/supplier/notifications/${notificationType}`}
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: `/supplier/notifications/${notificationType}/unsubscribe`,
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,

	supplierSettings: state.supplier_settings.detail,
	supplierSettingsFetching: state.supplier_settings.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	getSupplierSettings: (email) =>
		dispatch(supplierSettingsRestCrudThunksForSupplier.readOne(email)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierNotificationActions)
);
